__turbopack_context__.v({
  "accountActions": "CompanyAccountGate-module__bmTPta__accountActions",
  "accountBar": "CompanyAccountGate-module__bmTPta__accountBar",
  "accountHint": "CompanyAccountGate-module__bmTPta__accountHint",
  "accountName": "CompanyAccountGate-module__bmTPta__accountName",
  "card": "CompanyAccountGate-module__bmTPta__card",
  "codeRow": "CompanyAccountGate-module__bmTPta__codeRow",
  "connectionError": "CompanyAccountGate-module__bmTPta__connectionError",
  "error": "CompanyAccountGate-module__bmTPta__error",
  "eyebrow": "CompanyAccountGate-module__bmTPta__eyebrow",
  "features": "CompanyAccountGate-module__bmTPta__features",
  "fields": "CompanyAccountGate-module__bmTPta__fields",
  "footer": "CompanyAccountGate-module__bmTPta__footer",
  "formActions": "CompanyAccountGate-module__bmTPta__formActions",
  "header": "CompanyAccountGate-module__bmTPta__header",
  "illustration": "CompanyAccountGate-module__bmTPta__illustration",
  "layout": "CompanyAccountGate-module__bmTPta__layout",
  "methods": "CompanyAccountGate-module__bmTPta__methods",
  "note": "CompanyAccountGate-module__bmTPta__note",
  "notice": "CompanyAccountGate-module__bmTPta__notice",
  "page": "CompanyAccountGate-module__bmTPta__page",
  "panel": "CompanyAccountGate-module__bmTPta__panel",
  "passwordDialog": "CompanyAccountGate-module__bmTPta__passwordDialog",
  "passwordRow": "CompanyAccountGate-module__bmTPta__passwordRow",
  "story": "CompanyAccountGate-module__bmTPta__story",
  "submit": "CompanyAccountGate-module__bmTPta__submit",
  "subtitle": "CompanyAccountGate-module__bmTPta__subtitle",
  "workspace": "CompanyAccountGate-module__bmTPta__workspace",
  "workspaceBody": "CompanyAccountGate-module__bmTPta__workspaceBody",
  "workspaceName": "CompanyAccountGate-module__bmTPta__workspaceName",
});
